import React from 'react';
import { connect } from 'dva';
import { notification, Button } from 'antd';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import List from '../List';
import classes from './AccountCompletition.less';

/**
 * @description - It renders the final step of add cloud account process
 * @param {*} props
 * @returns {JSX}
 */
const AccountCompletion = props => {
  const {
    addAccFail,
    showAddErrMsg,
    showAssetApi,
    cloudAccountProvider,
    testingPageTitle,
    testConnectionTypes,
    protectionLevel,
    testCloudApis,
  } = props;
  const stepsArray = [
    {
      key: 'authentication',
      name: 'Authentication',
      status: 'passed',
      tooltip: 'Some information',
    },
    {
      key: 'resourcesAccess',
      // name: 'Resources Access',
      name: 'Access to Resources',
      status: 'passed',
      tooltip: 'Some information',
    },
    {
      key: 'misconfigurationDetection',
      // name: 'Misconfiguration Detection',
      name: 'CloudEye: Misconfiguration Detection',
      status: 'failed',
      tooltip: 'Some information',
    },
    {
      key: 'cloudXray',
      name: 'Cloudxray: Malware & OS Vulnerabilities Detection',
      status: 'passed',
      tooltip: 'Some information',
    },
    {
      key: 'eagleEye',
      name: 'EagleEye: Real-time threat detection',
      status: 'loading',
      tooltip: 'Some information',
    },
  ];

  const isConnectionsLoading = () =>
    testConnectionTypes &&
    Object.keys(testConnectionTypes).every(key => testConnectionTypes[key].loading === true);

  return (
    <div className={classes.container}>
      <>
        <h5>{isConnectionsLoading() ? 'Connecting...' : testingPageTitle}</h5>
        <List
          steps={stepsArray}
          protectionLevel={protectionLevel}
          testCloudApis={testCloudApis}
          cloudAccountProvider={cloudAccountProvider}
        />
      </>

      {/* {cloudAccountProvider === 'AZURE' && (
        <>
          <LegacyIcon
            type={addAccFail === true ? 'close-circle' : addAccFail === false ? 'check-circle' : ''}
            theme="filled"
            style={{
              color: addAccFail === true ? '#F4657C' : addAccFail === false ? '#6BC41D' : '',
              fontSize: '117px',
            }}
          />
          {showAssetApi ? (
            <h4 className={classes.status}>Provider Error</h4>
          ) : addAccFail ? (
            <h4 className={classes.status}>Invalid Credentials</h4>
          ) : (
            <>
              <h4 className={classes.status}>Cloud Account added successfully</h4>
              <div className="d-flex flex-column align-items-center">
                <p className="mb-1">Your cloud account is being scanned now!</p>
                <p>You can view the insights once the scan is completed.</p>
              </div>
            </>
          )}
          {addAccFail &&
            showAddErrMsg &&
            notification.error({ message: `Something went wrong while adding cloud account.` })}
        </>
      )} */}
    </div>
  );
};

export default connect(({ cloudAccount }) => ({
  testingPageTitle: cloudAccount.testingPageTitle,
  testConnectionTypes: cloudAccount.testConnectionTypes,
}))(AccountCompletion);
